import { HTTP_TOKEN_REPORT } from "./http";

export const getTraxTracker = params => {
  return HTTP_TOKEN_REPORT.get("tax-rate-tracker", { params }).then(result => {
    return result.data;
  });
};

